import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Users, User } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StaffPreview() {
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    axios.get(`${API}/staff`).then(r => setStaff(r.data || [])).catch(() => {});
  }, []);
  if (!staff.length) return null;

  return (
    <section className="py-24 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 items-end mb-12">
          <div>
            <div className="flex items-center gap-2 text-[#0e5469] uppercase tracking-[0.32em] text-xs font-bold mb-4">
              <Users className="h-3.5 w-3.5" /> Meet Our Team
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0a2d38] leading-[1.02] tracking-tight">
              Workers Together<br />
              <span className="text-[#c8a36a]">For God&rsquo;s Glory</span>
            </h2>
          </div>
          <div className="lg:pb-2">
            <p className="text-[#3b4d54] leading-relaxed text-lg">
              Our dedicated pastors and staff are here to provide spiritual guidance, prayer, and support &mdash; and to walk with you on your faith journey.
            </p>
            <Link to="/staff" className="mt-6 inline-flex items-center gap-2 bg-[#c8a36a] hover:bg-[#b48d52] text-[#0a2d38] rounded-full px-6 py-3 font-bold transition-colors">
              Meet the Team <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <Carousel opts={{ align: "start", loop: staff.length > 3 }} className="w-full">
          <CarouselContent className="-ml-4">
            {staff.map((s) => (
              <CarouselItem key={s.id} className="pl-4 basis-[80%] sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
                <Link to="/staff" className="group block relative aspect-[3/4] rounded-md overflow-hidden shadow-[0_18px_40px_-24px_rgba(14,84,105,0.35)]">
                  {s.photo ? (
                    <img src={s.photo} alt={s.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-[#e7dfd0] to-[#f5f2ec]">
                      <div className="h-20 w-20 rounded-full bg-[#0e5469] flex items-center justify-center">
                        <User className="h-8 w-8 text-[#c8a36a]" />
                      </div>
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                    {s.role && <div className="text-[11px] opacity-95 mb-1">{s.role}</div>}
                    <div className="text-xl font-bold leading-tight">{s.name}</div>
                  </div>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-3 mt-8">
            <CarouselPrevious className="static translate-y-0 h-11 w-11 bg-white border-[#e7dfd0] text-[#0a2d38] hover:bg-[#c8a36a] hover:text-white hover:border-[#c8a36a]" />
            <CarouselNext className="static translate-y-0 h-11 w-11 bg-white border-[#e7dfd0] text-[#0a2d38] hover:bg-[#c8a36a] hover:text-white hover:border-[#c8a36a]" />
          </div>
        </Carousel>
      </div>
    </section>
  );
}
